import { Box, Typography } from "@mui/material";
import React, { Component } from "react";
import './purchase.css';
import { CommonNavigationHeader } from "../../../Components/Common Components/CommonComponents";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import WantedList from "./WantedList";
import PurchaseOrder from "./PurchaseOrder";
import Vendor from "./Vendor";
import VendorPayment from "./VendorPayment";
import DirectPo from "./DirectPo";
import OrderList from "./OrderList";
import VendorMonthly from "./VendorMonthly";
import ConfirmOrderList from "./ConfirmOrderList";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { hasAccess } from "../../../Utility/AccessUtils";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";
import { ImagePaths } from "../../../Utility/ImagePaths";

const navigationHeaderList = [
    { id: 0, TabName: "Wanted List", value: "wanted_list" },
    { id: 1, TabName: "Purchase Order", value: "purchase_order" },
    { id: 2, TabName: "Vendor Payment", value: "vendorPayment"},
    { id: 3, TabName: "Vendor List", value: "vendor" },
    
]

class LabPurchase extends Component {
    // Helper function to check access for purchase tabs
    // Uses hasAccess from AccessUtils for simplified package-based access control
    checkPurchaseTabAccess = (tabName) => {
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const role = loggedInUserInfo?.is_super_admin ? "admin" : (loggedInUserInfo?.is_branch_admin ? "admin" : "user");
        
        // Map tab names to routes for hasAccess check
        const tabRouteMap = {
            "Wanted List": "/Purchase/WantedList",
            "Purchase Order": "/Purchase/PurchaseOrder",
            "Vendor Payment": "/Purchase/VendorPayment",
            "Vendor List": "/Purchase/VendorList"
        };
        
        const route = tabRouteMap[tabName];
        
        // For users, also check CheckAccessFunc for user-level permissions
        if (role === "user") {
            const checkAccessResult = CheckAccessFunc("Laboratory", "Purchase", tabName, null, "Tab");
            if (checkAccessResult?.viewAccess === false) {
                return {
                    viewAccess: false,
                    is_locked: checkAccessResult?.is_locked || false
                };
            }
        }
        
        // Use hasAccess for package-based access control
        if (route) {
            const accessResult = hasAccess(null, role, route);
            return {
                viewAccess: accessResult.allowed,
                is_locked: accessResult.locked
            };
        }
        
        // Fallback to CheckAccessFunc if no route mapping
        const checkAccessResult = CheckAccessFunc("Laboratory", "Purchase", tabName, null, "Tab");
        return {
            viewAccess: checkAccessResult?.viewAccess !== false,
            is_locked: checkAccessResult?.is_locked || false
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedScreen: "wanted_list",
            vendor_id: null,
            purchase_order_id: null,
            purchase_status: "",
            common_search: '',
            wantedList_search_key: '',
            orderList_search_key: '',
            purchaseOrder_search_key: '',
            vendorPayment_search_key: '',
            vendorList_search_key: '',
            screenType:'',
            showSuccessResponse: false,
            showErrorResponse:false ,
            responseMessage: ""
        }
    }

    componentDidMount(){
        this.props.changeScreen('4')
        
        // Ensure initial selected screen is valid for user access
        const filteredTabs = this.getFilteredNavigationTabs();
        if (filteredTabs.length > 0) {
            const currentTab = filteredTabs.find(t => t.value === this.state.selectedScreen);
            if (!currentTab) {
                // If current selection is not available, select first available tab
                this.setState({
                    selectedScreen: filteredTabs[0].value
                });
                this.props.subScreenChange(filteredTabs[0].value);
            } else {
                this.props.subScreenChange(this.state.selectedScreen);
            }
        } else {
            this.props.subScreenChange("wanted_list");
        }
    }

    componentWillReceiveProps(props) {
        var { selectedScreen } = this.state
        if (props.search != this.state.common_search) {
            this.setState({
                common_search: props.search
            })
            if (selectedScreen === "wanted_list") {
                this.setState({
                    wantedList_search_key: props.search
                })
            } else if (selectedScreen === "order_List") {
                this.setState({
                    orderList_search_key: props.search
                })
            } else if (selectedScreen === "purchase_order") {
                this.setState({
                    purchaseOrder_search_key: props.search
                })
            } else if (selectedScreen === "vendor") {
                this.setState({
                    vendorList_search_key: props.search
                })
            } else if (selectedScreen === "vendorPayment") {
                this.setState({
                    vendorPayment_search_key: props.search
                })
            }
        }
    }

    NavigateScreen(id) {
        // Use filtered tabs to get the correct tab
        const filteredTabs = this.getFilteredNavigationTabs();
        const selectedTab = filteredTabs[id];
        
        if (selectedTab) {
            this.setState({
                selectedScreen: selectedTab.value
            })
            this.props.clrSearch()
            this.props.subScreenChange(selectedTab.value)
        }
    }

    goBack(pagename, id, purchase_order_id, purchase_status, pageType){
        this.props.subScreenChange(pageType === "directPo" ? "directPo" : "");
        this.setState({
            selectedScreen: pagename,
            vendor_id: id,
            purchase_order_id: purchase_order_id ,
            purchase_status: purchase_status,
            screenType: pageType,
        })
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }

    msgClose(){
        this.setState({
            showSuccessResponse: false,
            showErrorResponse:false ,
            responseMessage: ""
        })
    }

    // Helper to render content based on access
    renderPurchaseContent = () => {
        const { selectedScreen } = this.state;
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const isAdmin = loggedInUserInfo?.is_super_admin || loggedInUserInfo?.is_branch_admin;
        
        // Map screen to tab name for access check
        const screenToTabMap = {
            "wanted_list": "Wanted List",
            "purchase_order": "Purchase Order",
            "vendor": "Vendor List",
            "vendorPayment": "Vendor Payment"
        };
        
        // Screens that don't need access check (sub-screens)
        const subScreens = ["order_List", "confirmOrder_list", "directPo", "vendorMonthly"];
        
        // If it's a sub-screen, render it directly
        if (subScreens.includes(selectedScreen)) {
            switch (selectedScreen) {
                case "order_List":
                    return <OrderList NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} search_key={this.state.orderList_search_key} />;
                case "confirmOrder_list":
                    return <ConfirmOrderList NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} vendor_id={this.state.vendor_id} />;
                case "directPo":
                    return <DirectPo NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} purchase_order_id={this.state.purchase_order_id} purchase_status={this.state.purchase_status} screenType={this.state.screenType} />;
                case "vendorMonthly":
                    return <VendorMonthly NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} vendor_id={this.state.vendor_id} />;
                default:
                    return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
            }
        }
        
        const tabName = screenToTabMap[selectedScreen];
        if (!tabName) {
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
        }
        
        const access = this.checkPurchaseTabAccess(tabName);
        const isLocked = access?.is_locked === true;
        const hasViewAccess = access?.viewAccess === true;
        
        // For admin: show lock screen if locked
        if (isAdmin && isLocked) {
            return (
                <Box sx={{ height: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white' }}>
                    <img src={ImagePaths.LockScreen.default} alt="Lock" />
                    <Typography sx={{ marginTop: '1vw', fontSize: '1.2vw', fontWeight: 600 }}>This feature is locked.</Typography>
                    <Typography sx={{ marginTop: '0.5vw', fontSize: '0.9vw', color: '#666' }}>Please contact your administrator to unlock this feature.</Typography>
                </Box>
            );
        }
        
        // For user: show no access if locked or no viewAccess
        if (!isAdmin && (isLocked || !hasViewAccess)) {
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
        }
        
        // Show the actual component
        switch (selectedScreen) {
            case "wanted_list":
                return <WantedList NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} search_key={this.state.wantedList_search_key} />;
            case "purchase_order":
                return <PurchaseOrder NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} search_key={this.state.purchaseOrder_search_key} />;
            case "vendor":
                return <Vendor NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} search_key={this.state.vendorList_search_key} />;
            case "vendorPayment":
                return <VendorPayment NavigateScreen={this.NavigateScreen.bind(this)} goBack={this.goBack.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} search_key={this.state.vendorPayment_search_key} />;
            default:
                return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
        }
    }

    // Get filtered navigation tabs based on user access
    getFilteredNavigationTabs = () => {
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const isAdmin = loggedInUserInfo?.is_super_admin || loggedInUserInfo?.is_branch_admin;
        
        // Admins see all tabs
        if (isAdmin) return navigationHeaderList;
        
        // For users: filter out tabs they don't have access to
        const filteredTabs = navigationHeaderList.filter(tab => {
            const access = this.checkPurchaseTabAccess(tab.TabName);
            return access?.viewAccess !== false && access?.is_locked !== true;
        });
        
        // Re-index the filtered tabs
        return filteredTabs.map((tab, index) => ({ ...tab, id: index }));
    }
    
    // Get the correct selected tab ID based on filtered tabs
    getFilteredSelectedTabID = (filteredTabs) => {
        const currentTab = navigationHeaderList.find(t => t.value === this.state.selectedScreen);
        if (!currentTab) return 0;
        
        const filteredIndex = filteredTabs.findIndex(t => t.TabName === currentTab.TabName);
        return filteredIndex >= 0 ? filteredIndex : 0;
    }

    render() {
        let {showSuccessResponse, showErrorResponse, responseMessage } = this.state
        
        // Get filtered tabs for users (hide tabs without access)
        const filteredTabs = this.getFilteredNavigationTabs();
        const filteredSelectedTabID = this.getFilteredSelectedTabID(filteredTabs);
        
        // If no tabs available for user, show message
        if (filteredTabs.length === 0) {
            return (
                <Box className="emedhub_Purchasecontainer">
                    <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>
                    {
                        showSuccessResponse ? <ToastMsg severity = {"success"} msg = {responseMessage}  msgPop={this.msgClose.bind(this)}/> : null
                    }
                    { 
                        showErrorResponse ? <ToastMsg severity = {"error"} msg = {responseMessage}  msgPop={this.msgClose.bind(this)}/> : null
                    }
                </Box>
            );
        }
        
        
        return (
            <Box className = "emedhub_Purchasecontainer">
                <CommonNavigationHeader menu={filteredTabs} NavigateScreen={this.NavigateScreen.bind(this)} selectedTabID={filteredSelectedTabID} />
                <div className = "emedhub_purchase_contentContainer">
                    {this.renderPurchaseContent()}
                </div>
                {
                    showSuccessResponse ? <ToastMsg severity = {"success"} msg = {responseMessage}  msgPop={this.msgClose.bind(this)}/> : null
                }
                { 
                    showErrorResponse ? <ToastMsg severity = {"error"} msg = {responseMessage}  msgPop={this.msgClose.bind(this)}/> : null
                }
            </Box>
        )
    }
}

export default LabPurchase;